import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import OwnerDetail from '../../pages/ownerDetail';
import * as ownerActions from '../../actions/owner';
import selector from './selector';
import { fetchingState } from '@constants';

const OwnerCreateModal = ({
  createdOwner,
  modalOpen,
  closeModal,
  resetOwner,
  setModalResult,
}) => {
  const createdOwnerJs =
    createdOwner && createdOwner.get('data') && createdOwner.get('data').toJS();

  useEffect(() => {
    if (modalOpen) {
      resetOwner();
    }
  }, [modalOpen]);

  useEffect(() => {
    if (modalOpen && createdOwnerJs) {
      setModalResult({
        ownerId: createdOwnerJs.ownerID,
        name: createdOwnerJs.name,
      });
      resetOwner();
      closeModal();
    }
  }, [createdOwner]);

  return (
    <Dialog fullWidth maxWidth="lg" open={modalOpen} onClose={closeModal}>
      <DialogTitle id="form-dialog-title">
        Create New Owner
        <CloseButton onClick={closeModal}>
          <CloseIcon />
        </CloseButton>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: 0 }}>
        <div style={{ position: 'relative' }}>
          <OwnerDetail embeddedView />
          <Button
            onClick={closeModal}
            color="primary"
            style={{ position: 'absolute', bottom: 80, right: 120 }}
          >
            Cancel
          </Button>
          {createdOwner &&
            createdOwner.get('state') === fetchingState.SAVING && (
              <CircularProgress
                size={30}
                style={{ position: 'absolute', bottom: 80, right: 10 }}
              />
            )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

OwnerCreateModal.propTypes = {
  createdOwner: ImmutablePropTypes.map,
  modalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  resetOwner: PropTypes.func.isRequired,
  setModalResult: PropTypes.func.isRequired,
};

const CloseButton = styled(IconButton)`
  &&& {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #888;
  }
`;

const mapDispatchToProps = dispatch => ({
  closeModal: bindActionCreators(ownerActions.closeOwnerCreateModal, dispatch),
  resetOwner: bindActionCreators(ownerActions.resetOwnerData, dispatch),
  setModalResult: bindActionCreators(
    ownerActions.setOwnerCreateModalResult,
    dispatch,
  ),
});

export default connect(
  selector,
  mapDispatchToProps,
)(OwnerCreateModal);
